<template>
	<div>
		<a-modal v-model="appvisible" :title="audit ? '服务费重新提交' : '服务费申请'" @ok="appOk" width="60%" :maskClosable="false">
			<a-form-model ref="ruleForm" :rules="rules" :model="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-model-item>
							<span class="spanClass" style="font-size: 16px; font-weight: 700;color: gray;">表单信息</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
						<ccChange :data="ccC" :money="moneY" @targetKeys="getdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="隶属公司" prop="companyId">
							<a-select allowClear placeholder="隶属公司" @change="handlecompanyplan" v-model="form.companyId">
								<a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="隶属部门" prop="deptId">
							<a-tree-select allowClear :treeData="deptTree" placeholder="隶属部门" :disabled="!this.form.companyId" v-model="form.deptId"
							 treeDefaultExpandAll>
							</a-tree-select>
							<!-- <a-select allowClear v-model="form.deptId" placeholder="隶属部门" :disabled="!this.form.companyId">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select> -->
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="付款事由" prop="paymentDetails">
							<a-input allowClear v-model="form.paymentDetails" placeholder="付款事由" />
						</a-form-model-item>
					</a-col>
					<!-- <a-col :span="8">
						<a-form-model-item label="款项用途" prop="types">
							<a-select allowClear placeholder="款项用途" disabled @change="typesChange" v-model="form.types">
								<a-select-option :value="index" v-for="(item, index) in typesMap" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col> -->
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="付款方式" prop="paymentMode">
							<a-select allowClear placeholder="付款方式" v-model="form.paymentMode">
								<a-select-option :value="index" v-for="(item, index) in paymentMap" :key="index">
									{{ item }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="支付日期">
							<a-date-picker valueFormat="YYYY-MM-DD" allowClear v-model="form.paymentDate" placeholder="支付日期" style="width: 227px" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="支付对象" prop="paymentObject">
							<a-input allowClear v-model="form.paymentObject" placeholder="支付对象" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="开户行" prop="bankOfDeposit">
							<a-input allowClear v-model="form.bankOfDeposit" placeholder="开户行" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="银行账户" prop="bankAccount">
							<a-input allowClear v-model="form.bankAccount" placeholder="银行账户" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="特殊备注">
							<a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" allowClear v-model="form.remark" placeholder="不能打印" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<div v-for="(item, index) in form.coverChargeInfos" :key="index">
					<a-row>
						<div class="pay_top">
							<span class="form_title" style="font-size: 16px; font-weight: 700;color: gray;">服务费{{ index + 1 }}</span>
							<a-icon class="close_icon" @click="close_service(index)" v-if="form.coverChargeInfos.length > 1" type="close" />
						</div>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="项目编号" :prop="'coverChargeInfos.' + index + '.projectCode'" :rules="{
		          required: true,
		          message: '请输入项目编号',
		          trigger: 'blur',
		        }">
								<a-input allowClear v-model="form.coverChargeInfos[index].projectCode" placeholder="项目编号" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="受检单位" :prop="'coverChargeInfos.' + index + '.inspectedUnit'" :rules="{
		          required: true,
		          message: '请输入受检单位',
		          trigger: 'blur',
		        }">
								<a-input allowClear v-model="form.coverChargeInfos[index].inspectedUnit" placeholder="受检单位" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="合同金额(元)" :prop="'coverChargeInfos.' + index + '.contractAmount'" :rules="{
		          required: true,
		          message: '请输入合同金额(元)',
		          trigger: 'blur',
		        }">
								<a-input allowClear v-model="form.coverChargeInfos[index].contractAmount" placeholder="合同金额" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="回款金额(元)" :prop="'coverChargeInfos.' + index + '.payBackAmount'" :rules="{
						  required: true,
						  message: '请输入回款金额(元)',
						  trigger: 'blur',
						}">
								<a-input allowClear v-model="form.coverChargeInfos[index].payBackAmount" placeholder="合同金额" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="收款日期" :prop="'coverChargeInfos.' + index + '.amountDate'" :rules="{
								  required: true,
								  message: '请选择收款日期',
								  trigger: 'change',
								}">
								<a-date-picker valueFormat="YYYY-MM-DD" allowClear v-model="form.coverChargeInfos[index].amountDate"
								 placeholder="收款日期" style="width: 227px" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="支付金额(元)" :prop="'coverChargeInfos.' + index + '.paymentAmount'" :rules="{
								  required: true,
								  message: '请输入支付金额(元)',
								  trigger: 'blur',
								}">
								<a-input allowClear v-model="form.coverChargeInfos[index].paymentAmount" @change="changeMoneyTotal"
								 placeholder="支付金额" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="备注">
								<a-input allowClear v-model="form.coverChargeInfos[index].remark" placeholder="备注" />
							</a-form-model-item>
						</a-col>
					</a-row>
				</div>
				<a-row>
					<div class="btn_last">
						<a-button type="primary" @click="add_service"> 新增服务费明细 </a-button>
					</div>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="总金额">
							<a-input disabled v-model="form.amountTotal" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="附件" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		getDeptListEnable2
	} from '@/api/system'
	import {
		cover_apply_code,
		cover_apply_save,
	} from '@/api/financial'
	import {
		tree_all
	} from '@/api/purchase'
	import ccChange from '@/components/module/ccChange'
	import uploadImgJava from '@/components/module/uploadImgJava.vue'
	export default {
		components: {
			ccChange,
			uploadImgJava
		},
		data() {
			return {
				rules: {
					companyId: [{
						required: true,
						message: '请选择隶属公司！'
					}],
					deptId: [{
						required: true,
						message: '请选择部门！'
					}],
					paymentDetails: [{
						required: true,
						message: '请输入付款事由！'
					}],
					paymentMode: [{
						required: true,
						message: '请选择付款方式！'
					}],
					paymentObject: [{
						required: true,
						message: '请输入支付对象！'
					}],
					bankOfDeposit: [{
						required: true,
						message: '请输入开户行！'
					}],
					bankAccount: [{
						required: true,
						message: '请输入银行账户！'
					}],

				},
				deptTree: [],
				scroll_y: 150,
				dept_id: '',
				code: '',
				asset_sn: '',
				headers: {},
				fileList: [],
				removeList: [],
				defaultFileList: [],
				file_name: '',
				upload: {
					asset_sn: '',
					dept_id: '',
				},
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				labelCol: {
					span: 9,
				},
				wrapperCol: {
					span: 15,
				},
				labelCol2: {
					span: 2
				},
				wrapperCol2: {
					span: 22
				},
				isRouterAlive: true,
				appvisible: false,
				companylist: [],
				form: {
					cc: [],
					deptId: undefined,
					companyId: undefined,
					paymentDetails: '',
					paymentMode: undefined,
					paymentDate: '',
					paymentObject: '',
					bankOfDeposit: '',
					bankAccount: '',
					amountTotal: '',
					remark: '',
					coverChargeInfos: [{
						projectCode: '',
						inspectedUnit: '',
						contractAmount: '',
						paymentAmount: '',
						amountDate: '',
						paymentAmount: '',
						remark: '',
					}],
				},
				deptlist: [],
				queryParam: {},
				dates: [],
				uploadDataImg: {
					code: '',
					type: 'cover',
				},
				ccC: 'review',
				moneY: '',
				audit: false,
			}
		},
		props: {
			data: {
				type: Object,
				default: true,
			},
		},
		watch: {
			data(val, old) {
				console.log(val, old)
			},
		},
		created() {
			tree_all().then(res=>{
				this.companylist = res.data[0]
				this.companylist.unshift({
						value: 0,
						title: '所有公司',
						children: [],
					})
			})
		},
		methods: {
			show(res) {
				console.log(res, 121)
				if (res) {
					this.audit = true
					this.form = res
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree, this.form.companyId)
						}
					})
				} else {
					this.form = {
						deptId: undefined,
						companyId: undefined,
						paymentDetails: '',
						paymentMode: undefined,
						paymentDate: '',
						paymentObject: '',
						bankOfDeposit: '',
						bankAccount: '',
						amountTotal: '',
						remark: '',
						coverChargeInfos: [{
							projectCode: '',
							inspectedUnit: '',
							contractAmount: '',
							paymentAmount: '',
							amountDate: '',
							paymentAmount: '',
							remark: '',
						}],
					}
				}
				this.appvisible = true
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				cover_apply_code().then(res => {
					this.code = res.data
					this.uploadDataImg.code = res.data
				})
			},
			add_service() {
				this.form.coverChargeInfos.push({
					projectCode: '',
					inspectedUnit: '',
					contractAmount: '',
					paymentAmount: '',
					amountDate: '',
					paymentAmount: '',
					remark: '',
				})
			},
			changeMoneyTotal() {
				this.form.amountTotal = 0
				this.form.coverChargeInfos.forEach(item => {
					this.form.amountTotal += Number(item.paymentAmount)
				})
				this.form.amountTotal = this.form.amountTotal.toFixed(2)
				this.moneY = this.form.amountTotal
			},
			close_service(index) {
				this.form.coverChargeInfos.splice(index, 1)
				this.changeMoneyTotal()
			},
			getdata(data) {
				this.form.cc = data
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			handlecompanyplan(value) {
				this.deptTree = []
				this.form.deptId = undefined
				this.$nextTick(() => {
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree, this.form.companyId)
						}
					})
				})
				// this.companylist.forEach((item) => {
				// 	if (item.dept_id == this.form.companyId) {
				// 		this.deptlist = item.child_lis
				// 	}
				// })
			},
			appOk() {
				console.log(11111111111111111111111111111111111111111111)
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
						this.form.title = this.$store.getters.userInfo.userName
						this.form.coverCode = this.code
						this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
						this.form.coverChargeInfos.forEach(item => {
							item.reviewAmount = item.paymentAmount
						})
						cover_apply_save(this.form).then(res => {
							if (res.code === 200) {
								this.$message.success('保存成功')
								this.$emit('ok')
								this.appvisible = false
							} else {
								this.$message.error(res.msg)
								this.isRouterAlive = false
								this.$nextTick(() => {
									this.isRouterAlive = true
								})
							}
						})
					}
				})
			},
		},
	}
</script>
